import { IMG } from "@/data/content";

const userImages = {
  dough: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/t99juu5t_20240919_105658.jpg",
  fish: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/4lv4nn8f_20231016_121153.jpg",
  tomatoes: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/ls6fczjs_20241009_100517.jpg",
  rhubarb: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/zy11e1i2_20260521_161359.jpg",
  pizza_prosciutto_close: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/wddk3inp_20260521_125419.jpg",
  pizza_prosciutto_peel: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/s919w18d_20260521_125410.jpg",
  pizza_margherita: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/wn3z1ftg_20260521_125109.jpg",
  asparagus: "https://customer-assets.emergentagent.com/job_feel-good-food-1/artifacts/nvqahf5p_20260520_104553.jpg",
};

const images = [
  { src: userImages.pizza_prosciutto_close, span: "row-span-2", label: "Prosciutto & Basil" },
  { src: userImages.tomatoes, span: "", label: "San Marzano" },
  { src: IMG.meal_prep_plated, span: "", label: "Meal Prep" },
  { src: userImages.dough, span: "", label: "Fresh Dough" },
  { src: userImages.asparagus, span: "", label: "Asparagus" },
  { src: userImages.pizza_margherita, span: "col-span-2", label: "Margherita" },
  { src: IMG.herbs, span: "", label: "Herbs" },
  { src: userImages.fish, span: "row-span-2", label: "Whole Fish" },
  { src: userImages.rhubarb, span: "", label: "Rhubarb" },
  { src: IMG.artichokes, span: "", label: "Artichokes" },
  { src: IMG.meal_prep_branded, span: "col-span-2", label: "Out of Eden Meal Prep" },
  { src: IMG.stock_pot, span: "", label: "House Stock" },
  { src: IMG.dough_ball, span: "", label: "Dough Proofing" },
  { src: IMG.romanesco_carrots, span: "", label: "Romanesco" },
  { src: IMG.mirepoix, span: "col-span-2", label: "Mirepoix" },
  { src: IMG.rainbow_carrots_wide, span: "", label: "Rainbow Carrots" },
  { src: userImages.pizza_prosciutto_peel, span: "col-span-2", label: "Wood-Fired" },
];

export default function Gallery() {
  return (
    <div data-testid="gallery-page">
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 lg:pt-24 pb-12">
        <div className="eyebrow mb-6">Gallery</div>
        <h1 className="font-serif-display text-5xl lg:text-7xl max-w-4xl leading-[1.04]" style={{ color: "var(--ooe-ink)" }}>
          From the cutting board to the table.
        </h1>
        <p className="mt-8 max-w-2xl text-[16px] leading-relaxed" style={{ color: "var(--ooe-ink-2)" }}>
          A visual record of our recent kitchens, events, and ingredients.
        </p>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 pb-32">
        <div className="grid grid-cols-2 md:grid-cols-3 grid-flow-dense gap-4 lg:gap-6">
          {images.map((im, i) => (
            <div
              key={i}
              className={`relative overflow-hidden ${im.span}`}
              style={{ aspectRatio: im.span.includes("row-span-2") ? "1/2" : "1/1", border: "1px solid var(--ooe-border)" }}
              data-testid={`gallery-tile-${i}`}
            >
              <img src={im.src} alt={im.label} className="w-full h-full object-cover gallery-img" />
              <div
                className="absolute bottom-0 left-0 right-0 px-4 py-3 flex justify-between items-center"
                style={{ background: "linear-gradient(to top, rgba(19,38,28,0.85), transparent)", color: "var(--ooe-on-dark)" }}
              >
                <div className="eyebrow" style={{ color: "rgba(249,248,246,0.85)", fontSize: 10 }}>{im.label}</div>
                <div className="font-serif-display text-sm">Out of Eden</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
